import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { notification } from 'antd';

import { useAppDispatch } from '@/core/redux/hooks';
import { appSettingsSelectors } from '@/core/redux/slices/app/selectors';
import { appSettingsActions } from '@/core/redux/slices/app/slice';

export const NotificationComponent: React.FC = () => {
  const appNotification = useSelector(appSettingsSelectors?.appNotification);

  const [api, contextHolder] = notification.useNotification();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (appNotification) {
      api.open({
        type: appNotification?.type,
        message: appNotification?.message,
        description: appNotification?.description,
      });
      dispatch(appSettingsActions.setAppNotification(null));
    }
  }, [appNotification]);

  return <>{contextHolder}</>;
};
